<p-dialog
    header="Header"
    [(visible)]="visible"
    [modal]="true"
    [position]="position"
    [closable]="closable"
    [showHeader]="false"
    [style]="{ width: '100%', margin: '0'}">
    <img *ngIf="hasImage" src="https://cdn.lokos.in//aajeevika-assets/images/{{imageName}}.svg" alt="">
    <p class="header-message">{{headerMessage}}</p>
    <p>{{message}}</p>
    <button type="button" (click)="onclick()">{{'ok' | translate}}</button>
</p-dialog>
